import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './MenuList.module.scss';

import { IMenuListProps } from './MenuList.d';
import { useHistory } from 'react-router-dom';

import RIGHT_ICON from 'images/right-arrow.png';
import { useMenuItem } from 'Pages/Blog/Helper/useMenuItem';

function MenuList({ onClose }: IMenuListProps) {
  const history = useHistory();
  const onClick = (link: string) => {
    history.replace(link);
    onClose();
  };

  const menuItem = useMenuItem();

  return (
    <div className={Styles['wrapper']}>
      {menuItem.map((item) => (
        <div className={Styles['menu-item']} onClick={() => onClick(item.link)}>
          <p className={Styles['menu-text']}>{item.name}</p>
          <KickImage
            src={RIGHT_ICON}
            alt="right-arrow"
            className={Styles['menu-icon']}
          />
        </div>
      ))}
    </div>
  );
}

export default MenuList;
